import React from "react";
import createReactClass from "create-react-class";
import ReactPropTypes from "prop-types";
import PureRenderMixin from "react-addons-pure-render-mixin";
import Immutable from "immutable";
import ImmutablePropTypes from "react-immutable-proptypes";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/pro-regular-svg-icons";

import Tooltip from "js/common/views/tooltips";
import ErrorMsg from "js/common/views/error";
import pure from "js/common/views/pure";
import * as Users from "js/common/users";
import * as Groups from "js/common/groups";
import * as SharingUtils from "js/common/views/sharing/utils";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

import {Button as FlatButton, IconButton, Menu, MenuItem} from "@mui/material";

const SavedConfigsMenu = createReactClass({
  mixins: [PureRenderMixin],

  propTypes: {
    headerLabel: ReactPropTypes.string.isRequired,
    ownershipTypeToSavedConfigs: ImmutablePropTypes.map.isRequired,
    onSavedConfigSelect: ReactPropTypes.func.isRequired,
    onRefreshConfigsRequest: ReactPropTypes.func,
    onAddConfigRequest: ReactPropTypes.func,
    onRemoveSavedConfigRequest: ReactPropTypes.func,
    onGenerateSavedConfigAsCsvRequest: ReactPropTypes.func,
    onShareSavedConfigRequest: ReactPropTypes.func,
    mainContent: ReactPropTypes.element,
    ownershipTypeToCustomDisplayName: ImmutablePropTypes.map,
    error: ReactPropTypes.string,
    isLoading: ReactPropTypes.bool,
    isGenerateSavedConfigAsCsvEnabled: ReactPropTypes.bool,
    extraIcons: ImmutablePropTypes.list,
    extraButtons: ImmutablePropTypes.list,
    isSavedConfigSharingEnabled: ReactPropTypes.bool,
    generatingAsCsvConfigId: ReactPropTypes.number
  },

  getDefaultProps() {
    return {
      ownershipTypeToCustomDisplayName: Immutable.Map()
    };
  },

  render() {
    const {
      headerLabel,
      ownershipTypeToSavedConfigs,
      ownershipTypeToCustomDisplayName,
      onSavedConfigSelect,
      isLoading,
      error,
      onRemoveSavedConfigRequest,
      extraButtons,
      extraIcons,
      isSavedConfigSharingEnabled,
      onShareSavedConfigRequest,
      onRefreshConfigsRequest,
      onAddConfigRequest,
      isGenerateSavedConfigAsCsvEnabled,
      onGenerateSavedConfigAsCsvRequest,
      generatingAsCsvConfigId,
      mainContent,
      theme,
      isScheduledReportsEnabled,
      scheduledReports,
      onScheduleConfigRequest,
      onEditScheduleConfigRequest
    } = this.props;

    const ownershipTypes = ["ownedConfigs", "sharedUserConfigs", "sharedGroupConfigs"];
    const deletableOwnershipTypes = ["ownedConfigs", "sharedUserConfigs"];
    const prefixWithNameOwnershipTypes = ["sharedUserConfigs", "sharedGroupConfigs"];
    const ownershipTypeToDisplayName = Immutable.fromJS({
      ownedConfigs: "Owned by me",
      sharedUserConfigs: "Shared with me",
      sharedGroupConfigs: "Shared with my group"
    });
    const isGeneratingCsv = !!generatingAsCsvConfigId;
    return (
        <div style={{display: "flex", height: "100%", overflowY: "auto", overflowX: "hidden", paddingBottom: 20}}>
          <div style={{width: "100%"}}>
            <Header
                theme={theme}
                label={headerLabel}
                onRefreshClick={onRefreshConfigsRequest}
                onAddClick={onAddConfigRequest}
            />

            {error && <ErrorMsg text={error} style={{margin: 0}} />}

            {isLoading ? (
                <LoadingReports />
            ) : (
                ownershipTypes.map((ownershipType) => (
                    <OwnershipTypeSection
                        theme={theme}
                        key={ownershipType}
                        ownershipTypeToCustomDisplayName={ownershipTypeToCustomDisplayName}
                        ownershipTypeToDisplayName={ownershipTypeToDisplayName}
                        ownershipTypeToSavedConfigs={ownershipTypeToSavedConfigs}
                        deletableOwnershipTypes={deletableOwnershipTypes}
                        prefixWithNameOwnershipTypes={prefixWithNameOwnershipTypes}
                        isGenerateSavedConfigAsCsvEnabled={isGenerateSavedConfigAsCsvEnabled}
                        extraButtons={extraButtons}
                        extraIcons={extraIcons}
                        isSavedConfigSharingEnabled={isSavedConfigSharingEnabled}
                        ownershipType={ownershipType}
                        generatingAsCsvConfigId={generatingAsCsvConfigId}
                        onSavedConfigSelect={onSavedConfigSelect}
                        isGeneratingCsv={isGeneratingCsv}
                        onGenerateSavedConfigAsCsvRequest={onGenerateSavedConfigAsCsvRequest}
                        onShareSavedConfigRequest={onShareSavedConfigRequest}
                        onRemoveSavedConfigRequest={onRemoveSavedConfigRequest}
                        isScheduledReportsEnabled={isScheduledReportsEnabled}
                        scheduledReports={scheduledReports}
                        onScheduleConfigRequest={onScheduleConfigRequest}
                        onEditScheduleConfigRequest={onEditScheduleConfigRequest}
                    />
                ))
            )}
          </div>

          {mainContent && (
              <div style={{width: "75%", height: "100vh", borderLeft: "solid 1px #1a1a1a"}}>{mainContent}</div>
          )}
        </div>
    );
  }
});

const Header = pure(({label = "", onRefreshClick = () => {}, onAddClick, theme}) => {
  const headerContainerStyle = (theme) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.background.card
  });
  return (
      <div
          style={{
            ...headerContainerStyle(theme),
            borderBottom: `1px solid ${theme.themeId === "light" ? theme.palette.border.main : "rgba(0,0,0,0.2)"}`
          }}
      >
        <h1 style={headerStyle(theme)}>{label}</h1>
        <div style={{display: "flex"}}>
          {onAddClick && (
              <Tooltip text="Add new" position="left">
                <IconButton style={{...iconButtonStyle(theme), marginRight: 8}} onClick={onAddClick} size="large">
                  <FontAwesomeIcon icon={faPlus} />
                </IconButton>
              </Tooltip>
          )}
          <Tooltip text="Refresh" position="left">
            <IconButton style={{...iconButtonStyle(theme), marginRight: 8}} onClick={onRefreshClick} size="large">
              <i className="bhi-refresh" style={{color: theme.palette.text.main, fontSize: 18}} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
  );
});

const OwnershipTypeSection = pure(
    ({
      ownershipTypeToCustomDisplayName,
      ownershipTypeToDisplayName,
      ownershipTypeToSavedConfigs,
      deletableOwnershipTypes,
      isGenerateSavedConfigAsCsvEnabled,
      extraButtons,
      extraIcons,
      isSavedConfigSharingEnabled,
      ownershipType,
      generatingAsCsvConfigId,
      onSavedConfigSelect,
      isGeneratingCsv,
      onGenerateSavedConfigAsCsvRequest,
      onShareSavedConfigRequest,
      onRemoveSavedConfigRequest,
      isScheduledReportsEnabled,
      scheduledReports,
      onScheduleConfigRequest,
      onEditScheduleConfigRequest,
      theme
    }) => {
      const customReportTypeSectionName = ownershipTypeToCustomDisplayName.get(ownershipType);
      const sectionHeader = customReportTypeSectionName
          ? customReportTypeSectionName
          : ownershipTypeToDisplayName.get(ownershipType);
      const savedConfigs = ownershipTypeToSavedConfigs.get(ownershipType);
      const isDeletable = deletableOwnershipTypes.includes(ownershipType);
      const currentUserId = Users.getCurrentUser().get("id");
      const subheaderStyle = (theme) => ({
        ...headerStyle(theme),
        background: theme.themeId === "light" ? theme.palette.background.paper : "rgba(0,0,0,0.3)",
        fontWeight: 400,
        fontSize: "13px",
        color: theme.palette.text.main,
        textTransform: "uppercase"
      });

      return (
          <div>
            <h2 style={subheaderStyle(theme)}>{sectionHeader}</h2>
            {(!savedConfigs || savedConfigs.isEmpty()) && <NothingToView theme={theme} />}

            {savedConfigs &&
                savedConfigs
                    .sortBy((config) => config.get("name").toLowerCase())
                    .map((config) => (
                        <MenuItemRow
                            key={config.get("id")}
                            config={config}
                            isDeletable={isDeletable}
                            isGenerateSavedConfigAsCsvEnabled={isGenerateSavedConfigAsCsvEnabled}
                            extraButtons={extraButtons}
                            extraIcons={extraIcons}
                            isSavedConfigSharingEnabled={isSavedConfigSharingEnabled}
                            ownershipType={ownershipType}
                            generatingAsCsvConfigId={generatingAsCsvConfigId}
                            onSavedConfigSelect={onSavedConfigSelect}
                            isGeneratingCsv={isGeneratingCsv}
                            onGenerateSavedConfigAsCsvRequest={onGenerateSavedConfigAsCsvRequest}
                            onShareSavedConfigRequest={onShareSavedConfigRequest}
                            onRemoveSavedConfigRequest={onRemoveSavedConfigRequest}
                            isScheduledReportsEnabled={isScheduledReportsEnabled}
                            scheduledReports={scheduledReports}
                            onScheduleConfigRequest={onScheduleConfigRequest}
                            onEditScheduleConfigRequest={onEditScheduleConfigRequest}
                            theme={theme}
                            removeEnabled={config.get("ownerId") === currentUserId}
                        />
                    ))}
          </div>
      );
    }
);

const MenuItemRow = React.memo(
    ({
      config,
      generatingAsCsvConfigId,
      onSavedConfigSelect,
      isGenerateSavedConfigAsCsvEnabled,
      isGeneratingCsv,
      onGenerateSavedConfigAsCsvRequest,
      extraButtons,
      extraIcons,
      isSavedConfigSharingEnabled,
      onShareSavedConfigRequest,
      isDeletable,
      onRemoveSavedConfigRequest,
      ownershipType,
      theme,
      removeEnabled,
      isScheduledReportsEnabled,
      scheduledReports,
      onScheduleConfigRequest,
      onEditScheduleConfigRequest
    }) => {
      const [anchorEl, setAnchorEl] = React.useState(null);
      const [isScheduledReportsOpen, setIsScheduledReportsOpen] = React.useState(true);

      const open = Boolean(anchorEl);

      const handleClick = (event) => {
        const target = event.currentTarget;
        setAnchorEl(target);
      };

      const handleClose = () => {
        setAnchorEl(null);
      };

      const menuItemStyle = (theme) => ({
        backgroundColor: theme.palette.background.card,
        borderTop: `1px solid ${theme.themeId === "light" ? theme.palette.border.lightest : "rgba(0,0,0,0.2)"}`,
        borderBottom: `1px solid ${theme.themeId === "light" ? "#fff" : theme.palette.border.light}`,
        display: "flex",
        padding: "0px 8px",
        alignItems: "center"
      });

      const editableBy = [];

      config
          .getIn(["sharedWith", "groups"])
          .filter((g) => g.get("permission") === "EDIT")
          .forEach((g) => editableBy.push(Groups.getGroup(g.get("id")).get("name")));
      config
          .getIn(["sharedWith", "users"])
          .filter((u) => u.get("permission") === "EDIT")
          .forEach((u) => editableBy.push(Users.getUser(u.get("id")).get("fullName")));

      const isGeneratingReportAsCsv = config.get("id") === generatingAsCsvConfigId;
      const isSystemDefault = config.get("systemDefault");
      const currentUserPermission = ownershipType === "ownedConfigs" ? "EDIT" :
          SharingUtils.getCurrentUserPermissionForConfig(config);
      const currentUserId = Users.getCurrentUser().get("id");
      const itemScheduledReports = scheduledReports
          ?.get(config.get("id"))
          ?.filter(report => {
            if (currentUserPermission === "EDIT") {
              return true;
            }
            return report.get("ownerId") === currentUserId;
          });

      return (
          <div data-test-id={"saved-config-" + config.get("id")} style={menuItemStyle(theme)}>
            {
              <Tooltip
                  customStyle={{flexGrow: 1, maxWidth: "calc(100% - 25px)"}}
                  disable={ownershipType === "ownedConfigs"}
                  maxWidth={400}
                  wrap={true}
                  tooltipHtml={() => (
                      <div style={{textAlign: "left"}}>
                        <span style={{opacity: 0.6}}>{config.get("name")}</span>
                        <br />
                        Creator: {Users.getUser(config.get("ownerId"))?.get("fullName")}
                        <br />
                        {editableBy.length > 0 && (
                            <span>
                    Editable by: {editableBy.sort().slice(0, 3).join(", ")}
                              {editableBy.length > 3 && `+${editableBy.length - 3} more`}
                  </span>
                        )}
                      </div>
                  )}
                  position="top"
              >
                <ConfigItem
                    config={config}
                    prefixWithName={false}
                    ownershipType={ownershipType}
                    onSavedConfigSelect={onSavedConfigSelect}
                    extraIcons={extraIcons}
                />
              </Tooltip>}

            <FlatButton
                aria-controls={open ? `menu-${config.get("id")}` : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                data-test-id={`${config.get("id")}-menu`}
                style={{
                  background: open ? theme.palette.background.card : "transparent",
                  padding: 0,
                  height: 20,
                  lineHeight: "20px",
                  minWidth: 20,
                  flexShrink: "none",
                  boxShadow: "none",
                  borderRadius: 5,
                  marginRight: 5
                }}
            >
              <i className="bhi-kebab-menu" style={{fontSize: 14}} data-test-id={"kebab-menu"} />
            </FlatButton>

            <Menu
                disablePortal={false}
                container={() => document.body}
                id={`menu-${config.get("id")}`}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                transitionDuration={0}
                PaperProps={{
                  style: {
                    background: theme.palette.background.card,
                    zIndex: 1500
                  }
                }}
                MenuListProps={{
                  style: {background: theme.palette.background.card},
                  padding: "0 5px"
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
            >
              {isGenerateSavedConfigAsCsvEnabled && (
                  <MenuItem
                      onClick={() => {
                        onGenerateSavedConfigAsCsvRequest(config);
                        handleClose();
                      }}
                      disabled={isGeneratingCsv}
                      style={{fontSize: 12, padding: "4px 8px"}}
                  >
                    <i
                        className={isGeneratingReportAsCsv ? "fa fa-spinner fa-pulse fa-1x" : "fa fa-file"}
                        style={{fontSize: 14, marginRight: 8}}
                    />
                    Generate as CSV
                  </MenuItem>
              )}

              {extraButtons &&
                  extraButtons.map((extraButton, index) => {
                    const pageId = config.get("id");
                    const isActive = extraButton.get("isActive")(pageId);
                    const text = isActive ? extraButton.get("activeTooltipText") : extraButton.get("tooltipText");

                    return (
                        <MenuItem
                            key={`${config.get("id")}-${index}`}
                            onClick={() => {
                              extraButton.get("onClick")(pageId);
                              handleClose();
                            }}
                            disabled={extraButton.get("disabled")}
                            style={{fontSize: 12, padding: "4px 8px"}}
                        >
                          <i
                              className={extraButton.get("faClass")}
                              style={{
                                fontSize: 12,
                                marginRight: 8,
                                color: isActive ? theme.palette.primary.main : "inherit"
                              }}
                          />
                          {text}
                        </MenuItem>
                    );
                  })}

              {isSavedConfigSharingEnabled && Users.getCurrentUser().get("dataVisibility") !== "SELF" && (
                  <MenuItem
                      onClick={() => {
                        onShareSavedConfigRequest(config);
                        handleClose();
                      }}
                      disabled={isGeneratingCsv}
                      style={{fontSize: 12, padding: "4px 8px"}}
                  >
                    <i
                        className="bhi-share"
                        style={{fontSize: 12, marginRight: 8}}
                        data-test-id={"share-saved-config"} />
                    Share
                  </MenuItem>
              )}

              {isScheduledReportsEnabled && onScheduleConfigRequest && (
                  <MenuItem
                      onClick={() => {
                        onScheduleConfigRequest(config);
                        handleClose();
                      }}
                      disabled={isGeneratingCsv}
                      style={{fontSize: 12, padding: "4px 8px"}}
                  >
                    <i className="bhi-outbound-email" style={{fontSize: 14, marginRight: 8}} />
                    Schedule Report
                  </MenuItem>
              )}

              {isScheduledReportsEnabled && itemScheduledReports &&
                  !itemScheduledReports.isEmpty() && [
                    <MenuItem
                        key="edit-scheduled-reports-header"
                        onClick={() => setIsScheduledReportsOpen(!isScheduledReportsOpen)}
                        style={{display: "flex", fontSize: 12, padding: "4px 8px", width: 224}}
                    >
                      <i className="bhi-edit" style={{fontSize: 14, marginRight: 8}} />
                      <span style={{flexGrow: 1}}>
                  Edit Scheduled Report{itemScheduledReports.size > 1 ? "s" : ""} ({itemScheduledReports.size})
                </span>
                      <i
                          className={isScheduledReportsOpen ? "bhi-sort-desc" : "bhi-next"}
                          style={{fontSize: 12, marginRight: 5}}
                      />
                    </MenuItem>,
                    isScheduledReportsOpen &&
                    itemScheduledReports
                        .map((report) => (
                            <MenuItem
                                title={report.get("name")}
                                key={`scheduled-report-${report.get("id")}`}
                                onClick={() => {
                                  onEditScheduleConfigRequest(report.get("id"), config.get("id"));
                                  handleClose();
                                }}
                                style={{
                                  fontSize: 11,
                                  padding: "6px 8px 6px 30px"
                                }}
                            >
                              {report.get("name").length > 24
                                  ? report.get("name").substring(0, 24) + "..."
                                  : report.get("name")}{" "}
                            </MenuItem>
                        ))
                        .toArray()
                  ]}

              {isDeletable && removeEnabled && (
                  <MenuItem
                      onClick={() => {
                        onRemoveSavedConfigRequest(config, ownershipType);
                        handleClose();
                      }}
                      disabled={isGeneratingCsv || isSystemDefault}
                      style={{fontSize: 12, padding: "4px 8px"}}
                  >
                    <i
                        className="bhi-times"
                        style={{fontSize: 12, marginRight: 8, color: "#A4262C"}}
                        data-test-id={"delete-saved-config"}
                    />
                    Remove
                  </MenuItem>
              )}
            </Menu>
          </div>
      );
    }
);

const ConfigItem = React.memo(({config, prefixWithName, onSavedConfigSelect, ownershipType, extraIcons}) => {
  const {theme} = React.useContext(CustomThemeContext);
  const configNameRef = React.useRef(null);
  const [isLongName, setIsLongName] = React.useState(false);
  React.useEffect(() => {
    if (configNameRef?.current?.offsetWidth < configNameRef?.current?.scrollWidth) {
      setIsLongName(true);
    }
  }, [configNameRef]);

  let namePrefix = "";
  if (prefixWithName) {
    const owner = Users.getUser(config.get("ownerId"));
    if (owner) {
      namePrefix = owner.get("firstName") + "'s ";
    }
  }

  const filteredExtraIcons = extraIcons?.filter((icon) => {
    const pageId = config.get("id");
    const isActive = icon.get("isActive")(pageId);
    const isDisabled = icon.get("disabled")(pageId);
    return isActive && !isDisabled;
  });

  const paddingForButtons = filteredExtraIcons ? (filteredExtraIcons?.size * 25) + 4 : 0;

  return (
      <div style={{display: "flex", width: "auto"}}>
        <FlatButton
            data-test-id={"load-saved-config"}
            style={{
              flexGrow: 1,
              height: "auto",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 12px",
              paddingRight: "4px",
              backgroundColor: theme.palette.background.card,
              boxShadow: "none",
              textTransform: "none"
            }}
            onClick={() => onSavedConfigSelect(config, ownershipType)}
        >
          <Tooltip
              customStyle={{maxWidth: `calc(100% - ${paddingForButtons}px)`}}
              maxWidth={300}
              width="max-content"
              wrap={true}
              text={config.get("name")}
              disable={!isLongName || ownershipType !== "ownedConfigs"}
              position={ownershipType === "ownedConfigs" ? "bottom" : "top"}
          >
            <div
                ref={configNameRef}
                style={{
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden"
                }}
            >
              {namePrefix}
              {config.get("name")}
            </div>
          </Tooltip>
          <div style={{display: "flex", gap: "6px"}}>
            {filteredExtraIcons &&
                filteredExtraIcons.map((icon, index) => {
                  const pageId = config.get("id");
                  const isDisabled = icon.get("disabled")(pageId);
                  const isActive = icon.get("isActive")(pageId);
                  const html = isActive ? icon.get("activeTooltipHtml")(pageId) : icon.get("tooltipHtml")(pageId);
                  if (isDisabled || !isActive) {
                    return null;
                  }

                  return (
                      <Tooltip
                          maxWidth={400}
                          wrap={true}
                          width="max-content"
                          key={index}
                          tooltipHtml={() => html}
                          disable={isDisabled || html === ""}
                          position="left"
                      >
                        <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: theme.palette.background.paper,
                              width: 22,
                              height: 22,
                              borderRadius: 3,
                              opacity: isDisabled ? 0.5 : 1,
                              cursor: isDisabled ? "not-allowed" : "pointer"
                            }}
                        >
                          <i
                              className={icon.get("faClass")}
                              style={{
                                fontSize: 12,
                                color: "inherit",
                                opacity: isActive ? 0.8 : 0.2
                              }}
                          />
                        </div>
                      </Tooltip>
                  );
                })}
          </div>
        </FlatButton>
      </div>
  );
});

const LoadingReports = () => (
    <div style={{textAlign: "center", textTransform: "uppercase", color: "#bbb", padding: 10}}>
      <span style={{paddingRight: 8}}>Loading</span>
      <i className="fa fa-spinner fa-pulse fa-1x" />
    </div>
);

const NothingToView = ({theme}) => {
  const emptyMenuStyle = (theme) => ({
    backgroundColor: theme.palette.background.card,
    borderTop: `1px solid ${theme.palette.border.lightest}`,
    borderBottom: `1px solid ${theme.themeId === "light" ? "#fff" : theme.palette.border.light}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 10,
    paddingBottom: 10,
    lineHeight: 1.5,
    fontSize: "14px",
    textAlign: "center",
    color: "#bbb"
  });
  return <div style={emptyMenuStyle(theme)}>Nothing to view</div>;
};

const headerStyle = (theme) => ({
  fontSize: theme.themeId === "light" ? "20px" : "11px",
  fontWeight: theme.themeId === "light" ? "600" : "400",
  padding: "15px 15px",
  color: theme.palette.text.main,
  lineHeight: 1
});

const iconButtonStyle = (theme) => ({
  color: theme.palette.text.main,
  backgroundColor: "transparent",
  padding: 0,
  width: 36,
  height: 24
});

const Wrapper = (props) => {
  const {theme} = React.useContext(CustomThemeContext);
  return <SavedConfigsMenu theme={theme} {...props} />;
};

SavedConfigsMenu.displayName = "SavedConfigsMenu";
export default Wrapper;